import { useEffect, useRef, forwardRef } from 'react'
import VideoJS from 'video.js'
import 'video.js/dist/video-js.css'

const VideoPlayer = forwardRef(({ paper, onTimeUpdate }, ref) => {
  const videoRef = useRef(null)
  const playerRef = useRef(null)

  useEffect(() => {
    if (!videoRef.current) return

    const player = VideoJS(videoRef.current, {
      controls: true,
      autoplay: false,
      responsive: true,
      fluid: true,
      preload: 'auto',
      controlBar: {
        remainingTimeDisplay: true,
        volumePanel: {
          inline: false,
        },
      },
      sources: [
        {
          src: `/content/${paper.source_path}`,
          type: 'video/mp4',
        },
      ],
    })

    playerRef.current = player

    const handleTimeUpdate = () => {
      if (onTimeUpdate) {
        onTimeUpdate(player.currentTime())
      }
    }

    player.on('timeupdate', handleTimeUpdate)

    return () => {
      if (playerRef.current && !playerRef.current.isDisposed()) {
        playerRef.current.dispose()
      }
    }
  }, [paper.source_path, onTimeUpdate])

  // Expose player to parent via ref
  useEffect(() => {
    if (ref) {
      ref.current = playerRef.current
    }
  }, [ref])

  return (
    <div className="w-full flex justify-center bg-white py-6">
      <div
        className="w-full max-w-5xl"
        style={{
          aspectRatio: '16 / 9',
          maxHeight: '600px'
        }}
      >
        <div data-vjs-player className="w-full h-full">
          <video
            ref={videoRef}
            className="video-js vjs-big-play-centered w-full h-full"
            crossOrigin="anonymous"
            poster={`/content/${paper.detail_path}`}
          />
        </div>
      </div>
    </div>
  )
})

VideoPlayer.displayName = 'VideoPlayer'

export default VideoPlayer